import imageProduct1 from "../assets/images/Shirts/shirtimg1.jpg";
import imageProduct2 from "../assets/images/Shirts/shirtimg2.jpg";
import imageProduct3 from "../assets/images/Shirts/shirtimg3.jpg";
import imageProduct4 from "../assets/images/Shirts/shirtimg4.jpg";
import imageProduct5 from "../assets/images/Shirts/shirtimg5.jpg";
import imageProduct6 from "../assets/images/Shirts/shirtimg6.jpg";
import imageProduct7 from "../assets/images/Shirts/shirtimg7.jpg";
import imageProduct8 from "../assets/images/Shirts/shirtimg8.jpg";
import imageProduct9 from "../assets/images/Shirts/shirtimg9.jpg";
import imageProduct10 from "../assets/images/Shirts/shirtimg10.jpg";
import imageProduct11 from "../assets/images/Shirts/shirtimg11.jpg";
import imageProduct12 from "../assets/images/Shirts/shirtimg12.jpg";





export const products = [
    {
        id: 1,
        name: "The Iron Grey",
        price: 2099,
        image: imageProduct1,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: "Grey Slim Fit Pure Linen Shirt",
        slug: 'hertfoid-upholstered-chair'
    },
    {
        id: 2,
        name: "The Soft Green",
        price: 2099,
        image: imageProduct2,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail..',
        shortdsc: "Soft Pistachio Slim Fit Pure Linen Shirt",
        slug: 'bingdon-pholstered-chair-swivel'
    },
    {
        id: 3,
        name: "The Olive Green",
        price: 2099,
        image: imageProduct3,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: " Olive Green Slim Fit Pure Linen Shirt",
        slug: 'jeses-minimore-modern-style-etta'
    },
    {
        id: 4,
        name: "The Pistachio Green",
        price: 2099,
        image: imageProduct4,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: "Pistachio Green Slim Fit Pure Linen ",
        slug: 'eses-minimore-modern-style-zakari'
    },
    {
        id: 5,
        name: "The German Grey",
        price: 2099,
        image: imageProduct5,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: " Grey Slim Fit Pure Linen Shirt ",
        slug: 'eses-miniuhsd-modern-style-zakari'
    },
    {
        id: 6,
        name: "The Navy Blue",
        price: 2099,
        image: imageProduct6,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: "Blue Slim Fit Pure Linen Shirt Pure ",
        slug: 'corrigan-studio-273-wide-armchair'
    },
    {
        id: 7,
        name: "The Natural Beige",
        price: 2099,
        image: imageProduct7,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: "Beige Slim Fit Pure Linen Shirt ",
        slug: 'leston-wide-upholstered-fabric'
    },
    {
        id: 8,
        name: "The Light Grey",
        price: 2099,
        image: imageProduct8,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: "Grey Slim Fit Pure Linen Shirt",
        slug: 'stephanny-275-wide-tufted-armchair'
    },
    {
        id: 9,
        name: "The Light Grey",
        price: 2099,
        image: imageProduct9,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: "Grey Slim Fit Pure Linen Shirt",
        slug: 'stdoephny-275-wide-tushed-armchair'
    },
    {
        id: 10,
        name: "The Light Blue",
        price: 2099,
        image: imageProduct10,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: "Blue Slim Fit Pure Linen Shirt",
        slug: 'stsudanny-285-wide-tufsdd-armchair'
    },
    {
        id: 11,
        name: "The Light Blue",
        price: 2099,
        image: imageProduct11,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: "Blue Slim Fit Pure Linen Shirt",
        slug: 'stedaeny-855-wide-tufted-arwiffair'
    },
    {
        id: 12,
        name: "The Navy Blue",
        price: 2099,
        image: imageProduct12,
        description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
        shortdsc: "Navy Blue Slim Fit Pure Linen Shirt",
        slug: 'sdwfphany-856-wide-tdgbed-armshair'
    },

    // **************************************
    // {
    //     id: 12,
    //     name: "The Navy Blue",
    //     price: 2099,
    //     image: imageProduct12,
    //     description: '100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos. Feel the luxurious fabric against your skin, the intricate weave whispering quality and attention to detail.',
    //     shortdsc: "Navy Blue Slim Fit Pure Linen Shirt",
    //     discount:"",
    //     stock:"",
    //     slug: 'sdwfphany-856-wide-tdgbed-armshair'
    // },
    // {
    //     "id": "101",
    //     "name": "Men's Cotton T-Shirt",
    //     "description": "100% Linen, The shirt is crafted from fine 100% linen. It is a breathable and versatile staple and great for teaming with jeans for a more casual look or smartening up with a classic pair of chinos.",
    //     "category": "Casual",
    //     "price": 499.99,
    //     "sizes": ["S", "M", "L", "XL"],
    //     "colors": ["Red", "Blue", "Black"],
    //     "images": ["red-shirt.jpg", "blue-shirt.jpg"],
    //     "stock": 25,
    //     "discount": 10,
    //     "material": "Cotton",
    //     "rating": 4.5,
    //     "tags": ["summer", "casual", "slim fit"]
    // }

];